var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogout(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.87109 3.28125V2.1875C9.87109 0.981277 8.88982 0 7.68359 0H2.1875C0.981277 0 0 0.981277 0 2.1875V11.8125C0 13.0187 0.981277 14 2.1875 14H7.68359C8.88982 14 9.87109 13.0187 9.87109 11.8125V10.7188C9.87109 10.4167 9.62628 10.1719 9.32422 10.1719C9.02216 10.1719 8.77734 10.4167 8.77734 10.7188V11.8125C8.77734 12.4156 8.28665 12.9062 7.68359 12.9062H2.1875C1.58444 12.9062 1.09375 12.4156 1.09375 11.8125V2.1875C1.09375 1.58444 1.58444 1.09375 2.1875 1.09375H7.68359C8.28665 1.09375 8.77734 1.58444 8.77734 2.1875V3.28125C8.77734 3.58331 9.02216 3.82812 9.32422 3.82812C9.62628 3.82812 9.87109 3.58331 9.87109 3.28125ZM13.5996 7.93941L12.375 9.164C12.1613 9.37762 11.8151 9.37762 11.6015 9.164C11.3879 8.95049 11.3879 8.6042 11.6015 8.39069L12.4726 7.51953H5.90625C5.60419 7.51953 5.35938 7.27472 5.35938 6.97266C5.35938 6.67059 5.60419 6.42578 5.90625 6.42578H12.4726L11.6015 5.55463C11.3879 5.34111 11.3879 4.99483 11.6015 4.78131C11.7084 4.6745 11.8483 4.62109 11.9882 4.62109C12.1282 4.62109 12.2682 4.6745 12.375 4.78131L13.5996 6.00591C14.1327 6.539 14.1327 7.40631 13.5996 7.93941Z",
    fill: "#606161"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogout);
export default __webpack_public_path__ + "static/media/logout.b192cd98b631aa6841277a9991100181.svg";
export { ForwardRef as ReactComponent };